<template>
  <path
    d="M20 2.00024H4C2.9 2.00024 2 2.90024 2 4.00024V22.0002L6 18.0002H20C21.1 18.0002 22 17.1002 22 16.0002V4.00024C22 2.90024 21.1 2.00024 20 2.00024ZM13 14.0002H11V12.0002H13V14.0002ZM12 10.0002C11.45 10.0002 11 9.55024 11 9.00024V7.00024C11 6.45024 11.45 6.00024 12 6.00024C12.55 6.00024 13 6.45024 13 7.00024V9.00024C13 9.55024 12.55 10.0002 12 10.0002Z"
  />
</template>
